import React from 'react'
import { browserIs } from 'tools/browser'

const { Provider, Consumer } = React.createContext(browserIs())
const BrowserProvider = Provider
const BrowserConsumer = Consumer

export {
  BrowserProvider,
  BrowserConsumer,
}



// WEBPACK FOOTER //
// ./src/contexts/browser-context.js